import React, {Component} from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/browser';

class RemoteComponent extends Component {
  constructor(props) {
    super(props)
    this.wrapper = React.createRef()
  }

  async componentDidMount() {
    const {id, url} = this.props
    const $injectedComponent = document.querySelector(`#${id}`)

    if ($injectedComponent) {
      const $parent = $injectedComponent.parentElement
      $parent.removeChild($injectedComponent)

      try {
        const response = await fetch(url, {headers: {accept: 'text/html'}})
        if (response.ok) {
          const $componentContent = await response.text()
          this.wrapper.current.appendChild(document.createRange().createContextualFragment($componentContent))
          $injectedComponent.style.display = 'block'
        } else {
          Sentry.captureException(new Error(`Error fetching remote component from ${url}`))
        }
      } catch (e) {
        Sentry.captureException(new Error(`Error fetching remote component from ${url}: ${e}`))
      }
    } else {
      Sentry.captureException(new Error(`Injected Element [#${id}] was not found in the document`))
    }
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return <div ref={this.wrapper} />
  }
}

RemoteComponent.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}

export default RemoteComponent
